import React from 'react'
import { getAvailablePatterns } from '../../utils/gridUtils'

const styles = {
  toolbar: {
    display: 'flex',
    gap: '16px',
    marginBottom: '16px',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: '12px 16px',
    background: 'var(--color-light)',
    border: '1px solid var(--color-border)',
  },
  group: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  label: {
    fontWeight: '600',
    fontSize: '0.9rem',
  },
  directionBadge: {
    padding: '4px 12px',
    background: 'var(--color-primary)',
    color: '#fff',
    fontWeight: '600',
    fontSize: '0.85rem',
  },
  checkbox: {
    width: '18px',
    height: '18px',
    cursor: 'pointer',
  },
  select: {
    padding: '6px 12px',
    border: '2px solid var(--color-border)',
    fontSize: '0.9rem',
    cursor: 'pointer',
  },
  btn: {
    padding: '6px 14px',
    border: '2px solid var(--color-border)',
    background: '#fff',
    color: 'var(--color-primary)',
    fontWeight: '600',
    cursor: 'pointer',
    fontSize: '0.9rem',
  },
  btnDanger: {
    borderColor: '#dc3545',
    color: '#dc3545',
  },
  shortcuts: {
    marginLeft: 'auto',
    fontSize: '0.8rem',
    color: 'var(--color-muted)',
    display: 'flex',
    gap: '12px',
    flexWrap: 'wrap',
  },
  shortcut: {
    display: 'flex',
    gap: '4px',
    alignItems: 'center',
  },
  kbd: {
    padding: '2px 6px',
    background: '#eee',
    border: '1px solid #ccc',
    borderRadius: '3px',
    fontFamily: 'var(--font-mono)',
    fontSize: '0.75rem',
  },
}

export default function EditorToolbar({
  direction,
  symmetryEnabled,
  setSymmetryEnabled,
  gridSize,
  onApplyPattern,
  onClearGrid,
}) {
  const patterns = getAvailablePatterns(gridSize)

  const handlePatternChange = (e) => {
    const patternKey = e.target.value
    if (patternKey) {
      onApplyPattern(patternKey)
      e.target.value = '' // Reset select
    }
  }

  return (
    <div style={styles.toolbar}>
      <div style={styles.group}>
        <span style={styles.label}>Direction:</span>
        <span style={styles.directionBadge}>
          {direction === 'across' ? 'Across →' : 'Down ↓'}
        </span>
      </div>

      <div style={styles.group}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
          <input
            type="checkbox"
            checked={symmetryEnabled}
            onChange={(e) => setSymmetryEnabled(e.target.checked)}
            style={styles.checkbox}
          />
          <span style={styles.label}>Symmetry</span>
        </label>
      </div>

      <div style={styles.group}>
        <select
          onChange={handlePatternChange}
          style={styles.select}
          defaultValue=""
        >
          <option value="" disabled>Apply Pattern...</option>
          {patterns.map(p => (
            <option key={p.key} value={p.key}>{p.name}</option>
          ))}
        </select>
      </div>

      <button
        style={{ ...styles.btn, ...styles.btnDanger }}
        onClick={() => {
          if (confirm('Clear all letters and black squares?')) {
            onClearGrid()
          }
        }}
      >
        Clear Grid
      </button>

      <div style={styles.shortcuts}>
        <span style={styles.shortcut}>
          <kbd style={styles.kbd}>A-Z</kbd> type
        </span>
        <span style={styles.shortcut}>
          <kbd style={styles.kbd}>.</kbd> black
        </span>
        <span style={styles.shortcut}>
          <kbd style={styles.kbd}>Space</kbd> direction
        </span>
        <span style={styles.shortcut}>
          <kbd style={styles.kbd}>Tab</kbd> next word
        </span>
      </div>
    </div>
  )
}
